import { defineMessages } from 'react-intl'

export default defineMessages({
  requestLink: {
    id: 'components.MemoryRequestActions.requestLink',
    defaultMessage: 'Request link',
  },
  selectLinkType: {
    id: 'components.MemoryRequestActions.selectLinkType',
    defaultMessage: 'What kind of link do you need?',
  },
  sharingLinkTitle: {
    id: 'components.MemoryRequestActions.sharingLinkTitle',
    defaultMessage: 'Sharing link',
  },
  sharingLinkDesc: {
    id: 'components.MemoryRequestActions.sharingLinkDesc',
    defaultMessage: 'Share recorded memories with recipients',
  },
  recordingRequestTitle: {
    id: 'components.MemoryRequestActions.recordingRequestTitle',
    defaultMessage: 'Recording request',
  },
  recordingRequestDesc: {
    id: 'components.MemoryRequestActions.recordingRequestDesc',
    defaultMessage: 'Ask someone to record these memories',
  },
  createLink: {
    id: 'components.MemoryRequestActions.createLink',
    defaultMessage: 'Create link',
  },
  creating: {
    id: 'components.MemoryRequestActions.creating',
    defaultMessage: 'Creating…',
  },
  cancel: {
    id: 'components.MemoryRequestActions.cancel',
    defaultMessage: 'Cancel',
  },
  sharingLinkCreated: {
    id: 'components.MemoryRequestActions.sharingLinkCreated',
    defaultMessage: 'Sharing link created',
  },
  recordingRequestLinkCreated: {
    id: 'components.MemoryRequestActions.recordingRequestLinkCreated',
    defaultMessage: 'Recording request link created',
  },
  copied: {
    id: 'components.MemoryRequestActions.copied',
    defaultMessage: 'Copied!',
  },
  copy: {
    id: 'components.MemoryRequestActions.copy',
    defaultMessage: 'Copy',
  },
  dismiss: {
    id: 'components.MemoryRequestActions.dismiss',
    defaultMessage: 'Dismiss',
  },
  brandPickerPlaceholder: {
    id: 'components.MemoryRequestActions.brandPickerPlaceholder',
    defaultMessage: 'Brand (optional) — search by name or paste a domain / URL / e-mail to fetch',
  },
  brandFetchLabel: {
    id: 'components.MemoryRequestActions.brandFetchLabel',
    defaultMessage: 'Fetch brand for domain:',
  },
})
